import { Dispatch, SetStateAction, useState, useEffect } from 'react';

export const useControlledState = <T>(initialState: T): [T, Dispatch<SetStateAction<T>>] => {
  const [controlledState, setControlledState] = useState<T>(initialState);

  useEffect(() => {
    setControlledState(initialState);
  }, [initialState]);

  return [controlledState, setControlledState];
};
